import { tableCellClasses } from "@mui/material";

export default function TableContainer(theme) {
  return {
    MuiTableContainer: {
      styleOverrides: {
        root: {
          boxShadow: "none !important",
        },
      },
    },

    MuiTableCell: {
      styleOverrides: {
        root: {
          [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.grey.gb,
            color: theme.palette.text.primary,
          },
          [`&.${tableCellClasses.body}`]: {
            fontSize: 14,
            color: `${theme.palette.text.secondary} !important`,
          },
        },
      },
    },
  };
}
